const createJigraPlatforms = (win) => {
    const defaultPlatformMap = new Map();
    defaultPlatformMap.set('web', { name: 'web' });
    const jigPlatforms = win.JigraPlatforms || {
        currentPlatform: { name: 'web' },
        platforms: defaultPlatformMap,
    };
    const addPlatform = (name, platform) => {
        jigPlatforms.platforms.set(name, platform);
    };
    const setPlatform = (name) => {
        if (jigPlatforms.platforms.has(name)) {
            jigPlatforms.currentPlatform = jigPlatforms.platforms.get(name);
        }
    };
    jigPlatforms.addPlatform = addPlatform;
    jigPlatforms.setPlatform = setPlatform;
    return jigPlatforms;
};
const initPlatforms = (win) => (win.JigraPlatforms = createJigraPlatforms(win));
/**
 * @deprecated Set `JigraCustomPlatform` on the window object prior to runtime executing in the web app instead
 */
export const JigraPlatforms = /*#__PURE__*/ initPlatforms((typeof globalThis !== 'undefined'
    ? globalThis
    : typeof self !== 'undefined'
        ? self
        : typeof window !== 'undefined'
            ? window
            : typeof global !== 'undefined'
                ? global
                : {}));
/**
 * @deprecated Set `JigraCustomPlatform` on the window object prior to runtime executing in the web app instead
 */
export const addPlatform = JigraPlatforms.addPlatform;
/**
 * @deprecated Set `JigraCustomPlatform` on the window object prior to runtime executing in the web app instead
 */
export const setPlatform = JigraPlatforms.setPlatform;
//# sourceMappingURL=platforms.js.map